import { render, staticRenderFns } from "./ActionCopy.vue?vue&type=template&id=1d1247ce&scoped=true&"
import script from "./ActionCopy.vue?vue&type=script&lang=js&"
export * from "./ActionCopy.vue?vue&type=script&lang=js&"
import style0 from "./ActionCopy.vue?vue&type=style&index=0&id=1d1247ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1247ce",
  null
  
)

export default component.exports